import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import * as enums from '../enums'

import * as dimensionFilter from './dimension-filter'

export const TRANSFORMER = graphql.transformers.IN.object<
  ents.extra.space.Record.Filter,
  graphql.schema.SpaceRecordsFilterInput
>({
  lastUpdatedBy: graphql.transformers.IN.list(transformers.PASS_THROUGH),
  orgFilter: dimensionFilter.TRANSFORMER,
  roomTypeFilter: dimensionFilter.TRANSFORMER,
  spaceFilter: dimensionFilter.TRANSFORMER,
  responsiblePersonFilter: () => undefined, // Responsible Person Filter is not supported in Lite version
  clusterFilter: () => undefined, // Cluster Filter is not supported in Lite version
  sqftMax: transformers.PASS_THROUGH,
  sqftMin: transformers.PASS_THROUGH,
  surveyStatuses: graphql.transformers.IN.list(
    graphql.transformers.IN.nonNull(enums.surveyStatus.TRANSFORMER),
  ),
  surveyStatusesLite: graphql.transformers.IN.list(
    graphql.transformers.IN.nonNull(enums.surveyStatus.TRANSFORMER),
  ),
  includeInaccessible: transformers.PASS_THROUGH,
  roomTypeCategories: graphql.transformers.IN.list(
    graphql.transformers.IN.nonNull(enums.roomTypeCategory.TRANSFORMER),
  ),
})
